import { render, staticRenderFns } from "./EmailDetails.vue?vue&type=template&id=264f0e33&scoped=true"
import script from "./EmailDetails.vue?vue&type=script&lang=js"
export * from "./EmailDetails.vue?vue&type=script&lang=js"
import style0 from "./EmailDetails.vue?vue&type=style&index=0&id=264f0e33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f0e33",
  null
  
)

export default component.exports